<template>
  <v-row 
    justify="center" 
    dense
  >
    <v-col cols="12">
      <v-row
        dense
        justify="center"
        class="mt-5"
      >
        <v-col 
          cols="12"
          sm="6"
          md="3"
          lg="2"
          class="d-flex justify-center mt-5"
        >
          <v-img src="@/assets/images/logo.png"/>
        </v-col>
      </v-row>
    </v-col>
    <v-col 
      cols="12"
      class="d-flex align-center justify-center text-md-h3 text-sm-h4 text-h5 font-weight-black grey--text"
      style="font-family: 'Roboto Condensed' !important;"
    >
      C-Cloud
    </v-col>
  </v-row>
</template>

<script>
export default {
}
</script>